<template>
  <div>
    <Alert
      v-if="newsletter_confirmation === '1'"
      class="kft-alert--info max-w-(--breakpoint-xl) m-auto px-4"
      close-card
      type="info"
      :title="$t('general.newsletter.confirmationAlertTitle')"
      :content="$t('general.newsletter.confirmationAlertText')"
    />
    <FeedbackBanner
      v-if="newsletter_unsubscribe === '1'"
      close-card
      type="info"
      :content="$t('general.waitlistUnsubscribedMessage')"
    />
    <FeedbackBanner
      v-if="showWaitingListAlert === '1'"
      close-card
      type="info"
      :content="$t('general.waitlistSubscribedMessage:')"
    />
    <FeedbackBanner
      v-if="showWaitlistUnsubscribedAlert === '1'"
      close-card
      type="info"
      :content="$t('general.waitlistUnsubscribedMessage')"
    />
    <FilteredProductShowcase
      :page-type="EventListPageType.SEARCH"
      :load-schema="false"
    />
  </div>
</template>

<script lang="ts" setup>
import { EventListPageType } from '~/composables/types/strapiEventListPage'

const route = useRoute()
const newsletter_confirmation =
  route?.query?.newsletter_confirmation?.toString() || null
const newsletter_unsubscribe =
  route?.query?.newsletter_unsubscribe?.toString() || null
const showWaitingListAlert =
  route?.query?.waitlist_confirmation?.toString() || null
const showWaitlistUnsubscribedAlert =
  route?.query?.waitlist_unsubscribe?.toString() || null

const searchPageMeta = filterByExistingTranslation({
  title: 'general.titles.search',
  description: 'general.descriptions.search',
  'og:title': 'general.titles.search',
  'og:description': 'general.descriptions.search',
})

const seoOptions = computed(() => ({
  meta: {
    ...searchPageMeta,
  },
}))

useSeoHelper(seoOptions)
</script>
